module.exports = __webpack_public_path__ + "static/media/auto.2e9f530e.png";